import { getFullUrl } from 'hubspot-url-utils';
import PortalPickerSubmenuItem from './PortalPickerSubmenuItem';
import { useIsHubless, useTranslation } from '../../hooks/useNavConfig';
import { StyledMenuPickerTopLink } from '../Menu';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PortalPickerSubmenu = ({
  accounts
}) => {
  const {
    t
  } = useTranslation();
  const isHubless = useIsHubless();
  const allAccountsId = 'allAccounts';
  const linkHref = `${getFullUrl('app')}/myaccounts-beta`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isHubless ? null : /*#__PURE__*/_jsx(StyledMenuPickerTopLink, {
      id: allAccountsId,
      href: linkHref,
      "data-test-id": "nav-account-menu-portal-picker-submenu",
      children: t('nav.tools.accounts')
    }), accounts.map(account => /*#__PURE__*/_jsx(PortalPickerSubmenuItem, {
      account: account
    }, account.id))]
  });
};
export default PortalPickerSubmenu;